import * as React from 'react';
import {TscButtonTypes, EmptyState, TscThemeNames} from '@techsmith/tsc-cloud-style-guide';
import {connect} from 'react-redux';
import ReduxState from '../../types/ReduxState';

const emptyStateContainer = ({title, text, imageSource, primaryButtonText, primaryButtonType, themeName, maxWidth, onPrimaryClick}: EmptyStateProps) => {
   return (
      <div className="empty-state-wrapper">
         <EmptyState title={title} text={text} imageSource={imageSource} primaryButtonText={primaryButtonText} primaryButtonType={primaryButtonType} themeName={themeName} maxWidth={maxWidth} onPrimaryClick={onPrimaryClick}/>
      </div>
   );
};

export interface EmptyStateProps {
   title?: string;
   text?: string;
   imageSource?: string;
   primaryButtonText?: string;
   primaryButtonType?: TscButtonTypes;
   themeName?: TscThemeNames;
   maxWidth?: string;
   onPrimaryClick?: React.MouseEventHandler;
}

const mapStateToProps = (state: ReduxState, ownProps: EmptyStateProps): EmptyStateProps => {
   return {
      title: ownProps.title,
      text: ownProps.text,
      imageSource: ownProps.imageSource,
      primaryButtonText: ownProps.primaryButtonText,
      primaryButtonType: ownProps.primaryButtonType,
      themeName: ownProps.themeName || state.themeName,
      maxWidth: ownProps.maxWidth,
      onPrimaryClick: ownProps.onPrimaryClick
   };
};

export default connect(mapStateToProps, null)(emptyStateContainer);
